/**
 * Maps flag names to special rules.
 *  - featureRule.name should match the flag name in LaunchDarkly.
 *  - featureRule.useRule is a function that takes the current flag value and the context
 *      and returns the new flag value with special rules applied.
 */

interface FeatureRule {
  name: string;
  useRule: (flagValue: any, context: any) => any;
}

class FeatureRules {
  private rules: Record<string, (flagValue: any, context: any) => any>;

  constructor(rulesArray: FeatureRule[]) {
    this.rules = {};
    rulesArray.forEach((featureRule) => {
      this.rules[featureRule.name] = featureRule.useRule;
    });
  }

  getRule(flagName: string) {
    return this.rules[flagName] || null;
  }
}

export default FeatureRules;
